<template>
    <header>
        <el-row :gutter="10">
            <el-col :sm="24" :lg="18">
                <slot></slot>
            </el-col>
            <el-col :sm="24" :lg="6" class="text-right">
                <el-button @click="reloadPageWhenRouteTheSame()"
                    >Submit project</el-button
                >
                <el-button v-if="isLogged" @click="logout">Logout</el-button>
                <router-link v-else :to="loginLink">
                    <el-button>Login</el-button>
                </router-link>
                <div class="navbutton">
                    <input class="checkbox" type="checkbox" v-model="drawer" />
                    <div class="hamburger-lines">
                        <span class="line line1"></span>
                        <span class="line line2"></span>
                        <span class="line line3"></span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-drawer
            title="Menu"
            :visible.sync="drawer"
            direction="rtl"
            :with-header="false"
            class="eldrawer"
        >
            <div class="drawermenu">
                <div class="drawersection">
                    <div class="hamburger-title">Awards Organizers</div>
                    <a href="https://www.chi-athenaeum.org/" target="_blank"
                        >The Chicago Athenaeum Museum</a
                    >
                    <a href="https://www.europeanarch.eu/" target="_blank"
                        >The European Centre for Architecture</a
                    >
                </div>
                <div class="drawersection">
                    <div class="hamburger-title">The Awards</div>
                    <a href="https://www.good-designawards.com/" target="_blank"
                        >Good Design Award</a
                    >
                    <a
                        href="https://www.internationalarchitectureawards.com/"
                        target="_blank"
                        >International Architecture Award</a
                    >
                    <a
                        href="https://www.americanarchitectureawards.com/"
                        target="_blank"
                        >American Architecture Award</a
                    >
                    <a
                        href="https://www.good-designawards.com/about-green-good-design.html"
                        target="_blank"
                        >Green Good Design Award</a
                    >
                    <a href="https://europe40under40.com/" target="_blank"
                        >Europe 40under40 Award</a
                    >
                    <a href="https://prizedesignsaward.com/" target="_blank"
                        >Prize Designs for Modern Furniture and Lighting</a
                    >
                    <a href="https://futurehouseaward.com/" target="_blank"
                        >Future House Awards</a
                    >
                </div>
                <div class="drawersection">
                    <div class="hamburger-title">Publication Orders</div>
                    <a
                        href="https://metropolitanartspress.com/shop/"
                        target="_blank"
                        >Metropolitan Arts Press</a
                    >
                </div>
                <div class="drawersection">
                    <div class="hamburger-title">Instructions</div>
                    <a
                        href="https://awardapplication.com/pdf/TCA-FORMS-INSRUCTIONS.pdf"
                        target="_blank"
                        >Online Applications</a
                    >
                </div>
                <div class="drawersection">
                    <div class="hamburger-title">Connect</div>
                    <a
                        href="https://www.instagram.com/thechicagoathenaeummuseum/"
                        target="_blank"
                        >Instagram</a
                    >
                    <a
                        href="https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm"
                        target="_blank"
                        >Facebook</a
                    >
                    <a
                        href="https://www.youtube.com/channel/UC6-D7BCiNxqXvDFrVBD9CKA/feed"
                        target="_blank"
                        >Youtube</a
                    >
                </div>
                <div class="drawersection">
                    <div class="hamburger-title">Contact</div>
                    <a href="#" target="_blank">curatorial@chi-athenaeum.org</a>
                    <a href="#" target="_blank"
                        >tel: +1 815 777 4444 (extension 3000)</a
                    >
                </div>
                <div class="drawersection">
                    <div class="hamburger-title">Legal</div>
                    <a href="/terms-and-conditions" target="_blank"
                        >Terms & Conditions</a
                    >
                    <a href="/refund-policy" target="_blank">Refund Policy</a>
                </div>
                <div class="drawersection">
                    <a href="#" v-if="isLogged" @click.prevent="logout"
                        >Logout</a
                    >
                    <router-link v-else :to="loginLink"> Login </router-link>
                </div>
            </div>
        </el-drawer>
    </header>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { TOGGLE_COLLAPSE } from "../store/types";

export default {
    name: "Header",
    data: () => ({
        drawer: false,
    }),
    methods: {
        ...mapMutations([TOGGLE_COLLAPSE]),
        logout: function () {
            this.$auth
                .logout({
                    makeRequest: true,
                    redirect: null,
                })
                .then(
                    () => {
                        this.$router.push(this.loginLink);
                    },
                    (error) => {
                        if (error.response.status === 422)
                            this.authErrors = error.response.data.errors;
                    }
                )
                .finally(() => (this.loading = false));
        },
        reloadPageWhenRouteTheSame() {
            if (
                this.$router.currentRoute.name !== "front-account" &&
                this.$router.currentRoute.name !== "front-submissions"
            ) {
                this.$router.go();
            } else {
                this.$router.push(this.$route.matched[1].path);
            }
        },
        collapse() {
            this[TOGGLE_COLLAPSE]();
        },
    },
    computed: {
        ...mapGetters(["coreIsCollapsed"]),
    },
    mounted() {
        const user = this.$auth.user();
    },
};
</script>
